import apiClient from "@/api/apiClient";
import { spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "users_to_workspaces";
const query = "*";

export const apiConfigUsersToWorkspaces: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const getUserToWorkspaces = async (user_id: string) => {
  const { data, error } = await apiClient.from(table).select(query).eq("user_id", user_id);
  if (error) throw error;
  return data;
};
export const updateUserToWorkspace = spawnUpdateApiFunction({ table, query });
export const deleteUserToWorkspace = async ({ workspace_id, user_id }: { workspace_id: string; user_id: string }) => {
  const { error, ...rest } = await apiClient.rpc("remove_user_from_workspace", {
    _workspace_id: workspace_id,
    _user_id: user_id,
  });
  if (error) throw error;

  return { error, ...rest };
};
